import { AppButton } from 'shared/UI/UIKit/Button';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppModal } from 'shared/UI/UIKit/Modal';
import { AppText } from 'shared/UI/UIKit/Text';
import { useDeleteClassGroupMutation } from 'shared/api';
import type { ClassGroup } from 'shared/api';

type DeleteClassGroupModalProps = {
  group: ClassGroup | null;
  className?: string;
  subjectName?: string;
  onClose: () => void;
  onSuccess: () => void;
};

export const DeleteClassGroupModal = ({
  group,
  className,
  subjectName,
  onClose,
  onSuccess,
}: DeleteClassGroupModalProps) => {
  const [deleteClassGroup, { isLoading }] = useDeleteClassGroupMutation();

  const onSubmit = async () => {
    if (!group) return;

    await deleteClassGroup(group.id).unwrap();
    onClose();
    onSuccess();
  };

  const footer = (
    <AppFlex direction="row">
      <AppButton color="danger" onClick={onSubmit}>
        Удалить
      </AppButton>
      <AppButton type="outline" onClick={onClose}>
        Отмена
      </AppButton>
    </AppFlex>
  );

  return (
    <AppModal
      visible={!!group}
      maskClosable={false}
      onCancel={onClose}
      destroyOnClose
      loading={isLoading}
      title="Удалить учебную группу"
      footer={footer}
      content={
        <AppFlex>
          <AppText type="secondary">Подтвердите удаление учебной группы</AppText>
          <AppText size={18}>
            {[group?.name, className, subjectName].filter(Boolean).join(' — ')}
          </AppText>
        </AppFlex>
      }
    />
  );
};
